import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';

const PasswordResetSuccess = () => {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: theme.palette.background.default
    }}>
      <Paper sx={{
        padding: 4,
        maxWidth: '500px',
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper
      }}>
        <EmailIcon sx={{ 
          fontSize: 60, 
          color: theme.palette.primary.main,
          mb: 2 
        }} />
        <Typography variant="h5" gutterBottom>
          Password Reset Link Sent
        </Typography>
        <Typography variant="body1" color="text.secondary">
          A password reset link has been sent to your email address. Please check your inbox and click the link to reset your password. If you don't see the email, please check your spam folder.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PasswordResetSuccess;